export interface VisitEvent {
  text: string;
  icon: string;
}

export interface Visit {
  time: number;
  sessionId: number;
  identifier: string;
  countryCode: string;
  uid: string;
  organization: string;
  netName: string;
  person: string;
  events: VisitEvent[];
  gravatarHash: string;
  commitment: number;
  labels?: any;
  geoLocation: string;
  secondaryHeader: string;
}

export class VisitsResponse {
  visits: Visit[];
  total: number;
  revenue: number;
}
